import VimeoPlayer from '@vimeo/player';
import HeroPlayer from './base-hero-player';

export default class VimeoHeroPlayer extends HeroPlayer {
  constructor() {
    super();

    this.el = document.querySelector(`#${this.getMountSelector()}`);

    if (this.el) {
      this.player = new VimeoPlayer(this.getMountSelector(), {
        id: this.el.getAttribute(`data-${HeroPlayer.TYPE.VIMEO}-id`),
      });

      this.player.on('ended', () => {
        this.toggleIframe();
      });
    }
  }

  play() {
    this.player.play();
  }

  pauseVideoListener() {
    this.player.pause();

    clearInterval(this.videoHeroPollerInterval);
    this.getHeroIframeContainer().removeEventListener('transitionend', this.pauseVideoListener);
  }

  getMountSelector() {
    return `${HeroPlayer.TYPE.VIMEO}-${HeroPlayer.SELECTOR_SUFFIX.PLAYER}`;
  }

  getHeroContainer() {
    return document.getElementById(`${HeroPlayer.TYPE.VIMEO}-${HeroPlayer.SELECTOR_SUFFIX.CONTAINER}`);
  }

  getHeroBadge() {
    return document.getElementById(`${HeroPlayer.TYPE.VIMEO}-${HeroPlayer.SELECTOR_SUFFIX.BADGE}`);
  }

  getHeroCover() {
    return document.getElementById(`${HeroPlayer.TYPE.VIMEO}-${HeroPlayer.SELECTOR_SUFFIX.COVER}`);
  }

  getHeroIframeContainer() {
    return document.getElementById(`${HeroPlayer.TYPE.VIMEO}-${HeroPlayer.SELECTOR_SUFFIX.IFRAME_CONTAINER}`);
  }
}